import { useEffect } from 'react';
import { useHttpStore } from '@tradingblock/storage';
import { IStorageProvider, HttpProviderConfig } from '@tradingblock/types';
import { config } from '../config';
import { useData } from '../state/selectors';
import { useDispatch } from 'react-redux';
import { applicationApiClient } from '../api/apiClient';
import { documentApiClient } from '../api/documentApiClient';
import { fileApiClient } from '../api/fileApiClient';

export const useStore = () => {
  const baseDataUrl = config.dataUrl;
  const authToken = useData(d => d.ui.storageToken);
  if (!baseDataUrl) {
    console.warn('baseDataUrl must be set!');
  }
  const storage: IStorageProvider<HttpProviderConfig> = useHttpStore(baseDataUrl || '', authToken);
  useEffect(() => {
    if (authToken && !storage.config.authToken) {
      storage.setConfig({ ...storage.config, authToken });
    }
  }, [authToken, storage]);
  return storage;
};

export const useApplicationStore = () => {
  const dispatch = useDispatch();
  const storage: IStorageProvider<HttpProviderConfig> = useStore();
  const apiClient = applicationApiClient(storage, dispatch);
  return apiClient;
};

export const useDocumentStore = () => {
  const dispatch = useDispatch();
  const storage: IStorageProvider<HttpProviderConfig> = useStore();
  const apiClient = documentApiClient(storage, dispatch);
  return apiClient;
};

export const useFileStore = () => {
  const dispatch = useDispatch();
  const storage: IStorageProvider<HttpProviderConfig> = useStore();
  const apiClient = fileApiClient(storage, dispatch);
  return apiClient;
};
